import { Skeleton } from '../../components/skeletons/Skeleton';

interface ProfileDescriptionProps {
  description?: string;
  isLoading: boolean;
}

/**
 * Profile description text section.
 */
export const ProfileDescription = ({ description, isLoading }: ProfileDescriptionProps) => {
  if (!description && !isLoading) {
    return null;
  }

  return (
    <div className="mt-1 flex items-center justify-center">
      {isLoading ? (
        <div className="w-1/2 space-y-2">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-4/5" />
        </div>
      ) : (
        <p className="mt-1 text-md text-center sm:w-[50%] m-auto">{description}</p>
      )}
    </div>
  );
};
